import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import PhotoGallery from './PhotoGallery';

const GalleryPage = () => {
  return (
    <div className="page-container">
      <Navigation />
      
      <main className="main-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="page-title">Photo Gallery</h1>
            <p className="page-subtitle">Capturing Panthers moments on and off the field</p>
          </div>
        </section>

        <section className="gallery-section">
          <div className="container">
            <PhotoGallery />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default GalleryPage;
